// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Hold viewer specific css not inside theme
*/

.geoview-map {
  box-sizing: border-box;
  position: relative !important;
}

/* smooth data table scrolling */
.MuiTableContainer-root {
  contain: paint;
  will-change: transform;
}

/*
 * Accessibility: Visually hidden content for screen readers
 * 
 * This CSS class is required for HTML string contexts where sanitizeHtmlContent()
 * processes user-generated content.
 * 
 * Usage:
 * - CSS class: For HTML string manipulation (e.g., linkified content from external sources)
 * - JS object: For React components using sx prop (e.g., <Box sx={visuallyHidden}>)
 */
.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip-path: inset(50%) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/style.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;;;;;;;EASE;AACF;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,8BAA8B;EAC9B,oBAAoB;AACtB","sourcesContent":["/*\nHold viewer specific css not inside theme\n*/\n\n.geoview-map {\n  box-sizing: border-box;\n  position: relative !important;\n}\n\n/* smooth data table scrolling */\n.MuiTableContainer-root {\n  contain: paint;\n  will-change: transform;\n}\n\n/*\n * Accessibility: Visually hidden content for screen readers\n * \n * This CSS class is required for HTML string contexts where sanitizeHtmlContent()\n * processes user-generated content.\n * \n * Usage:\n * - CSS class: For HTML string manipulation (e.g., linkified content from external sources)\n * - JS object: For React components using sx prop (e.g., <Box sx={visuallyHidden}>)\n */\n.visually-hidden {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip-path: inset(50%) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
